<template>
  <div class="price-active-tabs">
    <div
      class="price-active-tabs__tab"
      :class="{'is-active':activeTab===0}"
      @click="changeActiveTab(0)"
    >abceed<span class="text-wrap">単品課金</span></div>
    <div
      class="price-active-tabs__tab"
      :class="{'is-active':activeTab===1}"
      @click="changeActiveTab(1)"
    >abceed<span class="text-wrap" >月額課金</span></div>
    <div
      class="price-active-tabs__tab"
      :class="{'is-active':activeTab===2}"
      @click="changeActiveTab(2)"
    >abceed for school<span class="text-wrap">月額課金</span></div>
    <div
      class="price-active-tabs__tab"
      :class="{'is-active':activeTab===3}"
      @click="changeActiveTab(3)"
    >オリジナル<span class="text-wrap">コンテンツ</span></div>
  </div>
</template>

<script>
export default {
  props: {
    activeTab: {
      type: Number,
      required: true
    }
  },
  methods: {
    changeActiveTab(activeTab) {
      this.$emit("changeActiveTab", activeTab);
    }
  }
};
</script>

<style lang="scss" scoped>
.price-active-tabs {
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  background-color: #f1f1f1;
  border-bottom: #ff5b60;
  position: fixed;
  top: 50px;
  width: 100%;
  border-bottom: 1px solid #bdbdbd;
  &__tab {
    cursor: pointer;
    padding: 5px;
    &.is-active {
      color: #ff5b60;
      border: 1px solid #ff5b60;
      border-radius: 10px;
    }
  }
}
.text-wrap{
  @media screen and (max-width: 650px) {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/priceList/parts/PriceCategoryTabs.vue